import React from 'react';
import { SendIcon } from 'lucide-react';
export function TelegramButton() {
  return <a href="https://t.me/" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#0088cc] text-white shadow-lg transition-transform hover:scale-110 animate-pulse-glow" aria-label="Contactar por Telegram" data-id="element-257">
      <SendIcon className="h-6 w-6 ml-[-2px] mt-[2px]" data-id="element-258" />
    </a>;
}